<template>
  <transition name="blend">
    <div v-if="showMain" class="popup-main" :style="{ paddingTop: isFullScreen ? '0' : '50px' }">
      <transition name="popup">
        <div v-if="showContent" class="content" ref="contentContainer" :style="{ height: height ? height : '', minHeight: height ? height : '', maxHeight: height ? height : '',
          width: width ? width : '90%', maxWidth: width ? width : '400px', minWidth: width ? width : '' }" key="content">
          <div class="dragger" @dragstart="dragStart" @drag="dragging" @dragend="dragEnd" draggable="true"></div>
          <div class="header">
            <img v-if="type == 'success'" src="https://dsmapi.logistics.systems/dsm6gIcons/success.png" alt="">
            <img v-else-if="type == 'error'" src="https://dsmapi.logistics.systems/dsm6gIcons/error.png" alt="">
            <img v-else-if="type == 'warning'" src="https://dsmapi.logistics.systems/dsm6gIcons/warning.png" alt="">
            <img v-else-if="type == 'loading'" src="https://dsmlib.logistics.systems/Icons/Loading.gif" alt="">
            <img v-else-if="icon && icon !== '-'" :src="icon" alt="">
            <img v-else-if="icon !== '-'" src="https://dsmapi.logistics.systems/dsm6gIcons/icons8-info-64.png" alt="">
            <div class="title">{{ title }}</div>
          </div>
          <slot>
            <div style="white-space: pre-wrap; word-break: break-word;" v-html="content"></div>
          </slot>
          <div v-if="buttons" class="buttons" ref="buttons">
            <button v-if="buttons.length == 0" @click="btnClicked('OK')">OK</button>
            <button v-for="(b, i) in buttons" :key="i" :style="{ backgroundColor: b['color'] ? b['color'] : '',
              color: b['disabled'] ? ('rgba(128,128,128,0.5)') : (b['textColor'] ? b['textColor'] : 'black') }" @click="btnClicked(b['text'])"
              :disabled="b['disabled'] == undefined ? false : b['disabled']" v-html="b['text']"></button>
          </div>
        </div>
      </transition>
      <div class="popup-background" key="background" @click="backgroundClicked"></div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      showMain: false,
      showContent: false,

      contentObj: null,
      contentLeft: 0,
      contentWidth: 0,
      contentTop: 0,
      contentHeight: 0,
      dragOffsetX: 0,
      dragOffsetY: 0,
    }
  },
  props: {
    show: { type: Boolean, default: false },
    type: { type: String, default: '' },
    icon: { type: String, default: '' }, // pass in "-" will hide the icon
    title: { type: String, default: 'Title is not set' },
    content: { type: String, default: 'Content is not set' },
    buttons: { type: Array, default: function() { return [] } },
    height: { type: String, default: '' },
    width: { type: String, default: '' },
    isFullScreen: { type: Boolean, default: false },
    backgroundCancel: { type: Boolean, default: false },
  },
  methods: {
    btnClicked: function(e) {
      this.$emit('buttonClicked', e);
    },

    dragStart: function(e) {
      let rect = this.contentObj.getBoundingClientRect();
      this.contentLeft = rect.left;
      this.contentWidth = rect.width;
      this.contentTop = rect.top;
      this.contentHeight = rect.height;

      this.dragOffsetX = e.clientX - this.contentLeft;
      this.dragOffsetY = e.clientY - this.contentTop;
    },
    dragging: function(e) {
      this.contentObj.style.position = 'absolute';
      this.placePopup(e);
    },
    dragEnd: function(e) {
      this.placePopup(e);
    },
    placePopup: function(e) {
      let top = e['clientY'] - this.dragOffsetY;
      let left = e['clientX'] - this.dragOffsetX;
      let right = left + this.contentWidth;
      let bottom = top + this.contentHeight;

      if (top < 0 && left < 0) {
        return;
      }

      if (top < 0) {
        top = 0;
      } else if (bottom > window.innerHeight) {
        top = window.innerHeight - this.contentHeight;
      }

      if (left < 0) {
        left = 0;
      } else if(right > window.innerWidth) {
        left = window.innerWidth - this.contentWidth;
      }

      this.contentObj.style.top = `${top}px`;
      this.contentObj.style.left = `${left}px`;
    },

    backgroundClicked: function() {
      if (this.backgroundCancel) {
        this.$emit('buttonClicked', null);
      }
    }
  },
  mounted() {
  },
  watch: {
    show: function(val) {
      this.showMain = val;
      setTimeout(() => {
        this.showContent = val;

        if (val) {
          this.$nextTick(() => {
            const firstButton = (this.$refs['buttons'] || this.$refs['contentContainer']).querySelector('button:not([disabled])');
            if (firstButton) firstButton.focus();
            this.contentObj = this.$refs['contentContainer'];
          })
        } else {
          this.contentObj = null;
        }
      }, 50);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.popup-main {
  background-color: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99999;
  transition: 0.3s;
  font-size: 12px;
  padding-top: 50px;
}

.content {
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  // max-height: calc(100% - 20px);
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  > .dragger {
    min-height: 10px;
    width: 100%;
    background: transparent;
    cursor: url("https://www.google.com/intl/en_ALL/mapfiles/openhand.cur"), all-scroll;
    cursor: -webkit-grab;
    cursor: -moz-grab;
    cursor: -o-grab;
    cursor: -ms-grab;
    cursor: grab;

    &:active {
      cursor: url("https://www.google.com/intl/en_ALL/mapfiles/closedhand.cur"), all-scroll;
      cursor: -webkit-grabbing;
      cursor: -moz-grabbing;
      cursor: -o-grabbing;
      cursor: -ms-grabbing;
      cursor: grabbing;
    }
  }

  > .header, > .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > .title {
      font-weight: bold;
      text-align: center;
      font-size: 1.3em;
    }

    > button {
      min-width: 80%;
      max-width: 80%;
      margin: 3px 0;
    }

    > img {
      height: 75px;
    }
  }

  > .header {
    margin-bottom: 10px;
  }

  > .buttons {
    margin-top: 10px;

    > button:focus {
      outline: 3px solid gray;
    }
  }

  > :nth-child(3) {
    height: 100%;
    overflow: auto;
  }
}

.popup-background {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.blend-enter, .blend-leave-to {
  opacity: 0;
}

.popup-enter-active {
  animation: bounce 0.3s linear;
}

@keyframes bounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  // 65% {
  //   transform: scale(0.8);
  // }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
</style>
